import type React from "react";
import { Box, Group, Text } from "@mantine/core";

/** A compact settings row: label (and hint) left, control right. */
const SettingRow: React.FC<{ label: string; hint?: string; children: React.ReactNode }> = ({
  label,
  hint,
  children,
}) => (
  <Group justify="space-between" wrap="nowrap" gap="sm">
    <Box>
      <Text size="sm">{label}</Text>
      {hint && (
        <Text size="xs" c="dimmed">
          {hint}
        </Text>
      )}
    </Box>
    {children}
  </Group>
);

export default SettingRow;
